import styled from "@emotion/styled"
import {
  Switch as DefaultSwitch,
  SwitchProps as DefaultSwitchProps
} from "@chakra-ui/react"
import type { StylesProps } from "../../styles/common.styled"

export const SwitchContainer = styled(DefaultSwitch)<
  DefaultSwitchProps & StylesProps
>`
  .chakra-switch__track {
    background: ${({ isChecked, roomStyles }) =>
      isChecked
        ? roomStyles?.servicePanelElementSwitchActive
          ? `${roomStyles?.servicePanelElementSwitchActive} !important`
          : "#A0AEC0"
        : roomStyles?.servicePanelElementSwitchInactive ?? "#CBD5E0"};
    &[data-focus] {
      box-shadow: none;
    }
  }
  .chakra-switch__thumb {
    background: #fff;
  }
`
